import { ORDER, SORT } from "~~/constants/request_params";

export const formatRequestOptions = (options?: IRequestPaginatedOptions): IRequestPaginatedParams => ({
  page: options?.page || 0,
  size: options?.pageSize || 10,
  sort: options?.sort || SORT.order,
  order: options?.order || ORDER.asc,
  next: true,
  count: options?.count || false,
});
